import React from "react";
import Education from "./Education";
import InstituteForm from "./InstituteForm";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { FullColumn } from "../../../components/utility/rowColumn";
import LayoutWrapper from "../../../components/utility/layoutWrapper";
import "./index.css";
import Icons from "./Icons";


const Navbar = React.lazy(() => import("../../Navbar"));
const Footer = React.lazy(() => import("../../LandingPageComponents/footer"));

const EducationMainPage = () => {
  return (

    <HelmetProvider>
    <Helmet>
      <title>Logiglo Education</title>
      <link rel="canonical" href="https://logiglo.com/Education" />
      <meta property="og:title" content="Logiglo Education" />
      <meta property="og:description" content="Enhancing Careers Through Advanced Educational Resources and Visionary Insights for Lasting Growth and Success." />
      <meta property="og:image" content="https://opengraph.b-cdn.net/production/images/f8ba140a-981c-4421-a09e-ebae95b0534f.png?token=FXByuwPXqDXbCAr2fdnElBC4FiDHbW6vOC8r-8b_Kg0&height=675&width=1200&expires=33259546757" />
      <meta property="og:url" content="https://logiglo.com/Education" />
      <meta property="og:type" content="article" />

     
     <meta name="description" content="Enhancing Careers Through Advanced Educational Resources and Visionary Insights for Lasting Growth and Success." />
    
      <meta property="article:author" content="https://www.linkedin.com/in/saiteja123/" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Logiglo Education" />
      <meta name="twitter:description" content="Enhancing Careers Through Advanced Educational Resources and Visionary Insights for Lasting Growth and Success." />
      <meta name="twitter:image" content="https://opengraph.b-cdn.net/production/images/f8ba140a-981c-4421-a09e-ebae95b0534f.png?token=FXByuwPXqDXbCAr2fdnElBC4FiDHbW6vOC8r-8b_Kg0&height=675&width=1200&expires=33259546757" />


    </Helmet>

    <LayoutWrapper>
      
      <FullColumn>

    <div className="image">
      <Navbar />
      <h1 className="edu-heading">Learn, Grow and succeed!</h1>
      <h2 className="edu-tag-line">
        Enhancing Careers Through Advanced Educational Resources and Visionary
        Insights for Lasting Growth and Success.
      </h2>
      <p className="view-course"><a href="CourseList" > Explore all our courses today!</a></p>


      <Icons />
      <div className="edu-main-container">
        <Education />
        <InstituteForm />
      </div>
      <div style={{ backgroundColor: "white" }}>
        <Footer />
      </div>
    </div>
    </FullColumn>
    </LayoutWrapper>
    </HelmetProvider>
  );
};

export default EducationMainPage;
